/* eslint-disable no-undef */
/* eslint-disable func-names */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
export default function () {

    $(function () {
        $(".menu-item--has-children > a").click(function () {
          $(this).next(".menu-item__dropdown").toggleClass("open"); // Selects only the next one!
          return false;
        });
      });

    

}
